import axios from 'axios';
import { Dispatch, FormEvent, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../../styles/GlobalComponents';

import Spinner from '../../../components/common/Spinner';

import { P2, P3 } from '../../../styles/FontStyles';

import ReactCodeInput from 'react-code-input';
import { color } from '../../../styles/GlobalStyles';
// import { createWithdrawPartner } from './Withdraw.actions';

import { useAppSelector } from '../../../app/hooks';
import {
  ErrorToast,
  SuccessToast
} from '../../../components/common/Toasts/Toasts';
import { changeAvailableBalance } from '../../../slices/earnings-slice';
import { WithdrawSteps } from '../Earnings/Earnings';

interface WithdrawTwoFAProps {
  setStep: Dispatch<SetStateAction<number>>;
  amount: string;
  setAmount: Dispatch<SetStateAction<string>>;
}

export const WithdrawTwoFA = ({
  setStep,
  amount,
  setAmount
}: WithdrawTwoFAProps) => {
  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');
  const [loadingCode, setLoadingCode] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const dispatch = useDispatch();

  const { loading } = useAppSelector((state) => state.wallets);

  const { user } = useAppSelector((state) => state.auth.userInfo);

  const sendCode = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/travelution/withdraw/email/code`, {
        amount: parseInt(amount)
      });

      SuccessToast('Code sent successfully');
      setLoadingCode(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const createWithdraw = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/travelution/withdraw/confirm`, {
        amount: parseInt(amount),
        emailCode: code,
        twoFACode: code2Fa
      });

      setLoadingCode(false);
      setStep(WithdrawSteps.SUCCESS);

      setAmount('');

      dispatch(changeAvailableBalance(amount));
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    createWithdraw();
  };

  return (
    <div style={{ marginTop: '20vh' }}>
      {loading || loadingCode ? (
        <Spinner />
      ) : (
        <form onSubmit={onHandleSubmit}>
          <Flexed between>
            <P2 bold color={color.colors.neutral700}>
              Email verification code
            </P2>
            <P2
              bold
              style={{ cursor: 'pointer' }}
              color={color.colors.primary900}
              onClick={() => sendCode()}>
              Send Code
            </P2>
          </Flexed>
          <SecurityCodeWrapper>
            <ReactCodeInput
              fields={7}
              value={code}
              onChange={setCode}
              type={'number'}
              name='phone code'
              inputMode='numeric'
            />
          </SecurityCodeWrapper>
          <P3 color={color.colors.neutral500} mb='40'>
            {isCodeSent && `Enter the 7 digit code sent to ${user?.email}`}
          </P3>

          <div>
            <Flexed between>
              <P2 bold color={color.colors.neutral700}>
                2FA verification code
              </P2>
            </Flexed>
            <SecurityCodeWrapper is2Fa>
              <ReactCodeInput
                fields={6}
                value={code2Fa}
                onChange={setCode2Fa}
                type={'number'}
                name='phone code2 '
                inputMode='numeric'
              />
            </SecurityCodeWrapper>
            <P3 color={color.colors.neutral500} mb='10'>
              Enter the 6 digit code from your 2FA authenticator
            </P3>
          </div>

          <Button m='30px 0 10px 0' disabled={code === '' || code2Fa === ''}>
            Confirm
          </Button>
        </form>
      )}
    </div>
  );
};
